import { DailyLogOperationInstance } from '../projects/operation.models';
import { SetupChangeLogRecord } from '../setup/setup.models';
import { DateTime } from 'luxon';
import { PtLuxonDate } from '../projects/date.models';

export class TransitSummary {
  id: number;
  startDate: PtLuxonDate;
  endDate: PtLuxonDate;
  operationInstances: DailyLogOperationInstance[];
  setupChangeLogRecords: SetupChangeLogRecord[];

  mergePreviewOperationInstances: DailyLogOperationInstance[]
  // local use only
  integrityBroken: boolean;
}

export class AffectedTransitHelper {
  linkedTransit: TransitSummary;
  transitBeforeOperation: TransitSummary;
  transitAfterOperation: TransitSummary;
}

export class TransitSearchFilters {
  operationId?: number;
  // utc dates
  operationStartDate: DateTime;
  operationEndDate: DateTime;
}

export class TransitSaveHelper {
  transitSummary: TransitSummary;
}



// WEBPACK FOOTER //
// ./src/models/transit/transit.models.ts